// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_Bwr","cls2":"ProfilePdfPackCard-cls2_X_w ProfilePdfPackCard-cls1_Bwr"};